/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_BarkInputs */

const fr_fancy_vast_otter_bark = /** @type {(inputs: Fancy_Vast_Otter_BarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif`)
};

/**

* @param {Fancy_Vast_Otter_BarkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_bark = /** @type {((inputs?: Fancy_Vast_Otter_BarkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_BarkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_bark(inputs)
});